<template>
  <main class="main">
    <loading-container :loading="loading" >
      <div class="worker" style="position: relative">
        <!--<transition name="slide-in-down">
          <div class="worker-tag float" v-if="change_tags" >
            <loading-container :loading="change_tags_loader" height="99">
              <div class="worker-header">
                <div class="hitem">
                  <div class="hinputs">
                    <label class="worker-checkbox">
                      <input type="checkbox" v-model="labels.new">
                      <span class="checkmark top"></span>
                      <span class="text">Новинка</span>
                    </label>
                    <label class="worker-checkbox">
                      <input type="checkbox" v-model="labels.action">
                      <span class="checkmark top"></span>
                      <span class="text">Акция</span>
                    </label>
                    <label class="worker-checkbox">
                      <input type="checkbox" v-model="labels.preorder">
                      <span class="checkmark top"></span>
                      <span class="text">Предзаказной</span>
                    </label>
                    <label class="worker-checkbox">
                      <input type="checkbox" v-model="labels.exclusive">
                      <span class="checkmark top"></span>
                      <span class="text">Эксклюзивный</span>
                    </label>
                    <label class="worker-checkbox">
                      <input type="checkbox" v-model="labels.private">
                      <span class="checkmark top"></span>
                      <span class="text">Приватный</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="worker-header">
                <div class="hitem">
                  <div class="hinputs mr">
                    <input placeholder="Назначить теги" v-model="tags">
                  </div>
                  <button class="worker-add" style="width: max-content; padding: 0 40px" @click="changeLabels()">Применить</button>
                </div>

              </div>
            </loading-container>
          </div>
        </transition>-->
        <div>
          <div class="worker-header">
            <div class="hitem">
              <div class="hinputs">
                <input autocomplete="off" placeholder="Введите для поиска наименование продукции или бренда" @keyup="search()" v-model="search_name">
                <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
              </div>
            </div>
          </div>
          <div class="worker-header">
            <div class="hitem">
              <div class="hinputs no mr">
                <app-select :options="providers" :value="provider" @input="changeProvider($event)" placeholder="Поставщики"/>
              </div>
              <div class="hinputs no mr">
                <v-select :options="brands" :value="brand" @input="changeBrand($event)" placeholder="Бренд"></v-select>
              </div>
              <div class="hinputs no">
                <app-select :options="types" :value="type" @input="changeType($event)" placeholder="Тип товара"/>
              </div>
              <app-button class="ml-auto w-25" @click="addCheckedBasket()" :disabled="disabled_checked">Добавить к заказу</app-button>
            </div>

          </div>
          <div class="worker-header">
            <div class="hitem">
              <div style="margin-left: 15px">
                <app-checkbox v-model="contract">Есть договор с поставщиком</app-checkbox>
              </div>
              <div class="favorite">
                <app-checkbox v-model="favorit">Избранные</app-checkbox>
              </div>
              <div class="favorite" v-if="$store.getters.getCompany.dropshipping">
                <app-checkbox v-model="dropshipping">Дропшиппинг</app-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="worker-container">
            <div class="worker-main">
              <loading-container :loading="loading_product" height="500">
                <table class="worker-table">
                  <thead style="padding-top: 3px">
                  <tr>
                    <th>Фото</th>
                    <th>Артикул</th>
                    <th>Тип товара</th>
                    <th>Наименование</th>
                    <th width="70px">Избр-е</th>
                    <th>Поставщик</th>
                    <th width="120px">Цена РРЦ, руб.</th>
                    <th width="120px">Цена ОПТ, руб.</th>
                    <th>Остаток</th>
                    <th width="66px">шт/уп</th>
                    <th width="82px">К-во, шт.</th>
                    <th width="50px">
                      <app-checkbox
                          @change="checkAll"
                          :value="top_checked"
                          :disabled="products.length == 0"
                          :indeterminate="top_indeterminate"
                          white
                          table
                      />
                    </th>
                  </tr>
                  </thead>

                  <tbody class="table-scroller">
                  <tr v-for="product in products" :key="product.id">
                    <td class="ta-center"><img :src="product.image ? product.image.image : ''" class="product-image" alt=""></td>
                    <td>{{product.article}}</td>
                    <td>
                      <product-labels :labels="product.labels" />
                    </td>
                    <td>
                      <router-link class="product-link" :to="'product/' + product.id" target="_blank" tag="a">
                          {{product.name}}
                      </router-link>
                    </td>
                    <td>
                      <app-checkbox class="checkbox-center" :value="product.favorite ? product.favorite.favorite : 0" @change="changeFavorites(product.id)" white table/>
                    </td>
                    <!--<td>{{product.company.name}}</td>-->
                    <router-link :to="'profile/' + product.company.id" tag="td">
                      {{product.company.name}}
                    </router-link>
                    <td class="text-right">{{product.price_rcc | currency}}</td>
                    <td class="text-right">{{product.price_opt | currency}}</td>
                    <td class="text-right">{{product.quantity}}</td>
                    <td class="text-right">{{product.main_attr != null ? product.main_attr.count_in_pkg : ''}}</td>
                    <td>
                      <app-chevron-counter v-model="product_count[product.id]" class="ml-auto mw"/>
                    </td>
                    <td v-if="product.modifications.length == 0">
                      <app-checkbox v-model="checked[product.id]" white table/>
                    </td>
                    <td v-if="product.modifications.length > 0">
                      <span @click="$refs.pinm.open(product.modifications)">{{product.category_id == 237 ? 'Выбрать размер' : 'Выбрать'}}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </loading-container>
            </div>
            <div class="wrp">
              <div class="info">
                <div class="ser"><img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">Найдено <div class="num">{{total}}</div></div>
                <app-grey-select
                    :options="[30, 50, 100]"
                    v-model="show_count"
                    @input="changeCount($event)"
                />
              </div>
              <pagination
                  v-show="last_page > 1"
                  v-model="page"
                  :page-count="last_page"
                  :click-handler="getProducts"
              />
            </div>
          </div>
          <div class="tree-container">
            <div class="worker-main tree-place">
              <tree :data="catalog" :key="key"  @node:checked="select" @node:unchecked="select"/>
            </div>
            <!--<app-button class="catalog-btn" @click="page = 1; search_name = ''; getProducts()">Показать</app-button>-->
            <app-button class="go-to-btn" @click="$router.push('/order')">Перейти в форму заказа</app-button>
            <app-button class="go-to-btn" @click="$refs.downPrice.open(providers)">Скачать прайс</app-button>
          </div>
        </div>
      </div>
      <place-in-order-modal ref="pinm"/>
      <download-price-modal ref="downPrice"/>
    </loading-container>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppSelect from "@/components/app-select";
import Pagination from "@/components/pagination";
import AppGreySelect from "@/components/app-grey-select";
import AppCheckbox from "@/components/app-checkbox";
import AppChevronCounter from "@/components/app-chevron-counter";
import PlaceInOrderModal from "@/components/modals/place-in-order-modal";
import AppButton from "@/components/app-button";
import DownloadPriceModal from "@/components/modals/download-price-modal";
import ProductLabels from "@/components/product-labels";

export default {
  name: "edit",
  data: ()=>({
    test: [],
    t: null,
    contract: false,
    favorit: false,
    top_checked: false,
    top_indeterminate: false,
    loading: true,
    loading_product: false,
    active: 0,
    providers: [],
    catalog: [],
    search_name: '',
    products: [],
    provider: '',
    brands: ['Бренд 1', 'Бренд 2'],
    brand: '',
    types: ['Все', 'Новинка', 'Акция', 'Предзаказной', 'Эксклюзивный', 'Приватный', 'Распродажа'],
    type: '',
    warehouse: '',
    selected: [],
    page: 1,
    show_count: 30,
    show_pagin: false,
    disabled_checked: true,
    last_page: 0,
    total: 0,
    checked: [],
    product_count: [],
    change_tags: 0,
    change_tags_loader: false,
    tags: '',
    dropshipping: false,
    key: 1,
    labels: {
      new: false,
      action: false,
      preorder: false,
      exclusive: false,
      private: false
    }
  }),
  mounted() {
    if(this.$route.query.page) {
      if (this.$route.query.search) {
        this.search_name = this.$route.query.search;
      }
      if (this.$route.query.categories) {
        this.selected = this.$route.query.categories.split(',')
      }
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      }
      if (this.$route.query.contract) {
        this.contract = this.$route.query.contract ? true : false;
      }
      if (this.$route.query.favorit) {
        this.favorit = this.$route.query.favorit ? true : false;
      }

      if (this.$route.query.show_count) {
        this.show_count = this.$route.query.show_count;
      }

      this.page = Number(this.$route.query.page);

      /*this.countWatcher();*/
      this.getProducts();

    }

    if (this.$route.query.dropshipping) {
      this.dropshipping = this.$route.query.dropshipping ? true : false;
    }
    this.getCategories()
    this.getProviders()
    this.getBrands()
  },
  components: {
    AppButton,
    AppCheckbox,
    AppGreySelect,
    AppSelect,
    LoadingContainer,
    Pagination,
    AppChevronCounter,
    PlaceInOrderModal,
    DownloadPriceModal,
    ProductLabels
  },
  methods: {
    getBrands() {
      console.log('testing!')
      this.$http.post( '/get-all-products',{
        token: localStorage.getItem('token'),
        categories: this.selected,
        search: this.search_name,
        page: this.page,
        perPage: this.show_count,
        type: this.type,
        provider: this.provider ? this.provider.id : '',
        contract: this.contract ? 1 : 0,
        favorit: this.favorit ? 1 : 0,
        dropshipping: this.dropshipping ? 1 : 0,
        brand: this.brand ? this.brand.id : '',
        getBrands: '1',
      })
          .then(({data}) => {
            if (data.products) {
              this.brands = data.brands;
            }
          })
          .finally(()=> this.loading_product = false)

    },
    changeFavorites(id){
      this.$http.post( '/change-favorite-product',{
        token: localStorage.getItem('token'),
        product_id: id
      }).then(({data}) => {
        console.log(data);
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    checkAll(e){
      let checked = []
      this.products.forEach((item)=>{
        checked[item.id] = e.target.checked
      })
      this.checked = checked
    },
    view(id) {
      this.$router.push({name: 'viewStorePoint', params : {id}});
    },
    labelsReset(){
      this.labels= {
            new: false,
            action: false,
            preorder: false,
            exclusive: false,
            private: false
      }
    },
    getCategories() {
      this.$http.post( '/get-all-categories',{
        token: localStorage.getItem('token'),
        dropshipping: this.dropshipping ? 1 : 0
      }).then(({data}) => {
        if (data.categories) {
          if(this.$route.query.categories != undefined){
            data.categories = this.autoSelect(data.categories)
          }

          this.catalog = data.categories;
          this.key++;
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
        .finally(()=> this.loading = false)
    },
    getProviders() {
      this.$http.post('/get-providers',{
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.providers) {
         for (let key in data.providers) {
           this.providers.push({id: data.providers[key].id, label: data.providers[key].company.name});
         }
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    autoSelect(data){
      let selected = this.$route.query.categories.split(',')
      let th = this

      return data.map((item)=>{
        if(item.children){
          item.children = th.autoSelect(item.children)
        }
        item.state = {}
        if(selected.some(sel => {
          return String(sel) == String(item.id)
        })){
          item.state.checked = true
        }else{
          item.state.checked = false
        }
        return item;
      })
    },
    select(val) {
      this.selected = [];
      if(this.t)clearTimeout(this.t)
      val.tree.checkedNodes.forEach((item)=>{
        this.selected.push(item.id)
      })
      this.t = setTimeout(()=>{
        this.page = 1;
        this.search_name = '';
        this.getProducts();
        //TODO: Ивент для селекта и обновления
        //console.log ('select')
      },100)
    },
    getProducts(brand) {
      this.loading_product = true;
      this.changeUrl();
      this.$http.post( '/get-all-products',{
        token: localStorage.getItem('token'),
        categories: this.selected,
        search: this.search_name,
        page: this.page,
        perPage: this.show_count,
        type: this.type,
        provider: this.provider ? this.provider.id : '',
        contract: this.contract ? 1 : 0,
        favorit: this.favorit ? 1 : 0,
        dropshipping: this.dropshipping ? 1 : 0,
        brand: this.brand ? this.brand.id : '',
        brand_name: brand
      })
          .then(({data}) => {
            if (data.products) {
              this.products = data.products.data;
              this.show_pagin = true;
              this.brands = data.brands;
              this.last_page = data.products.last_page;
              this.total = data.products.total;
              this.checked = [];
              this.products.forEach((item)=>{
                this.checked[item.id] = false;
                this.product_count[item.id] = 1;
              })
            }
          })
          .finally(()=> this.loading_product = false)
    },
    changePage(page) {
      this.page = page;
      this.getProducts();
    },
    search() {
      this.page = 1;
      this.getProducts(this.search_name);
    },
    changeUrl() {

      let url = '/items?page=' + this.page;

      if (this.search_name) {
        url = url + '&search=' + this.search_name;
      }

      if(this.selected.length > 0) {
        url = url + '&categories=' + this.selected.join(',');
      }

      if(this.type) {
        url = url + '&type=' + this.type;
      }

      if(this.provider) {
        url = url + '&provider=' + this.provider.id;
      }

      if(this.contract) {
        let cont = this.contract ? 1 : 0;
        url = url + '&contract=' + cont;
      }

      if(this.show_count) {
        url = url + '&show_count=' + this.show_count;
      }

      history.pushState(null, null, url);
    },
    changeType(val) {
      this.type = val;
      this.page = 1;
      this.getProducts();
    },
    changeProvider(val) {
      this.provider = val;
      this.page = 1;
      this.getProducts();
    },
    changeBrand(val) {
      this.brand = val
      this.page = 1;
      this.getProducts(this.brand);
    },
    /*countWatcher() {
      this.$watch('show_count', function() {
        this.page = 1;
        this.getProducts();
      });
    },*/
    changeCount(val) {
      this.show_count = val;
      this.page = 1;
      this.getProducts();
    },
    addCheckedBasket() {
      let products = [];
      for (let key in this.checked) {
        if (this.checked[key]) {
          products.push({id: key, count: this.product_count[key]});
        }
      }
      if (products.length > 0) {
        this.$http.post( '/add-group-products',{
          token: localStorage.getItem('token'),
          products: products,
          dropshipping: this.dropshipping
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Товары добавлены в форму заказа!');
            this.checkAll({target: {checked: false}})
          }
        })
      } else {
        this.$toast.warning('Товары не выбраны!');
      }
    },
    changeDropshippingBasket() {
      this.$http.post('/change-dropshipping-basket',{
        token: localStorage.getItem('token'),
      }).then(() => {
      }).catch(function(){
      })
    }
  },
  watch: {
    checked(array) {
      let show = false;
      for (let key in array) {
        if (array[key]) {
          show = true
        }
      }
      this.change_tags = show;
      this.top_indeterminate = false;
      if(array.length > 0){
        if(array.every(item => item)) this.top_checked = true;
        else if(array.some(item => item)) this.top_indeterminate = true;
        else this.top_checked = this.top_indeterminate = false;
      }else{
        this.top_checked = false;
      }
      this.disabled_checked = this.checked.indexOf(true) != -1 ? false : true;
    },
    product_count:{
      deep: true,
      handler(arr){
        arr.forEach((item,i)=>{
          if(item > 1){
            this.checked[i] = true
            this.disabled_checked = false
          }
          if(item < 1){
            this.checked[i] = false
            this.disabled_checked = true
          }
        })
      }
    },
    contract: function() {
      this.page = 1;
      this.getProducts();
    },
    favorit: function() {
      this.page = 1;
      this.getProducts();
    },
    dropshipping: function() {
      this.products = [];
      this.selected = [];
      this.getCategories();
      this.changeUrl();
      this.page = 1;
      this.last_page = 1;
      this.total = 0;
      if (this.dropshipping) {
        this.changeDropshippingBasket();
      }
    }
  }
}
</script>

<style>
.checkbox-center {
    margin: 0 auto !important;
}
.mw {
  min-width: 53px;
}

.ta-center {
  text-align: center !important;
  vertical-align: middle !important;
}

.product-image {
  max-width: 40px;
  max-height: 40px;
}
.worker-table thead tr:first-child th, .worker-table tbody tr:first-child td, .worker-table {
  border-top: none !important;
}
.worker-table thead tr:first-child th::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid #a3a3a3;
  border-top: 1px solid #a3a3a3;
}
.v-select{
  margin: 0 !important;
}
</style>
<style scoped lang="scss">
.product-link {
  color: #7A818F;
  text-decoration: none;
}
.table-scroller {
  max-height: 600px;
  overflow: auto;
}
.tree-container {
  width: 22%;
  margin-right: 8px;
}
.catalog-btn {
  margin: 8px 0px 8px 8px !important;
  width: 100% !important;
}
.go-to-btn {
  margin: 8px 8px !important;
  width: 100% !important;
}
.action {
  width: 35px;
  cursor: pointer;
  padding: 0 !important;

  img{
    display: block;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
.wrap{
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
}
.worker {
  position: relative !important;

  &-container{
    width: 77%;
    .wrp{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .select{
        width: 40%;
      }
      .info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
        color: #7A818F;
        .ser{
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          background: #EEF0F3;
          border-radius: 4px;
          position: relative;
          padding: 0 15px;
          margin-right: 5px;
          img{
            margin-right: 5px;
          }
          .num{
            color: black;
            margin: 0 5px;
            font-weight: 500;
          }
        }
        .out{
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          background: #EEF0F3;
          border-radius: 4px;
          position: relative;
          padding: 0 15px;
          margin-right: 5px;
          .num{
            color: black;
            margin: 0 5px;
            font-weight: 500;
          }
        }
      }
      .wht{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 36px;
        font-weight: 500;
        font-size: 14px;
        border: 1px solid #B6BCC8;
        color: #7A818F;
        height: 40px;
        outline: none;
        border-radius: 4px;
        margin:0 0 0 auto ;
      }
    }
  }
  &-main{
    height: 500px;
    overflow-y: auto;
    /*border-radius: 5px;*/
    box-shadow: 0px 0px 3px #E5E5EA;
    outline: hidden;
    background: #fff;

    margin-right: auto;
    &.tree-place{
      height: 402px;
      max-width: 100%;
      width: 100%;
      padding-top: 10px;
      margin-left: 8px;
    }
  }
  &-table {
    border-collapse: collapse;
    width: 100%;
    background: #fff;
    border: 1px #a3a3a3 solid;
    border-radius: 5px;


    & > thead > tr > th{
      top: 0px;
      position: sticky;
      z-index: 5;
      margin: 0;
      background-color: white;
      color: #2D3137;
    }


    tr {
      &:nth-child(even) {
        background: #F9F9FB;
      }
    }
    th, td {
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      padding: 7px 14px;
      height: 40px;
      text-align: left;
      /*img{
        margin-right: -11px;
        margin-left: 2px;
      }*/
      &.true{
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #2CB181;        }
      &:not(:last-child) {
        border-right: 1px #a3a3a3 solid;
      }
    }
    th {
      top: 0;
      margin: 0;
      background-color: white;
      z-index: 5;
      position: sticky;
      color: #2D3137;
    }
    td{
      cursor: pointer;
    }
    tr {
      color: #7A818F;
    }
  }
  &-tag{
    background: #F9F9FB;
    box-shadow: 0px 4px 30px rgba(132, 132, 132, 0.25);
    border-radius: 0px 0px 4px 4px;
    margin-top: -30px;
    padding: 20px 20px  1px 20px;
    margin-bottom: 20px;
    position: absolute;
    width: 100%;
    transition: .5s;

    &.float {
      position: absolute;
      top: 10px;
      left: 0;
      z-index: 10;
    }
  }
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .hitem{
      width: 100%;
      display: flex;
      align-items: center;
    }

    .hinputs {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      margin: 0;

      &.no{
        max-width: 20%;
      }
      &.mr{
        margin-right: 15px;
      }
      div {
        width: 100%;
      }

       input {
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 12px;
        width: 100%;
        height: 40px;
        padding: 0 40px 0 15px;
        outline: none;
      }

      > img {
        position: absolute;
        right: 15px;
        bottom: 50%;
        transform: translateY(50%);
        width: 14px;
        height: 14px;
      }
    &-navigation{
      width: 60%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 8px 0 0;
      background-color: #FFFFFF;
      border-radius: 0px;
      button{
        height: 40px;
        border: none;
        outline: none;
        width: 100%;
        background-color: #FFFFFF;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #7A818F;
        cursor: pointer;
        padding: 0 15px;
        margin: 2px 0;
        border-radius: 0px;
      }
      .active{
        background: #EEF0F3;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #2D3137;
        margin: 0 -5px;
      }
      hr{
        height: 20px;
        border: 1px solid #EEF0F3;
      }
    }
  }
  }
  &-action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      height: 20px;
      border: none;
      background: none;
      cursor: pointer;
      outline: none;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.favorite{
  margin-left: 15px;
}
@media(max-width: 1200px) {
  .main {
    width: 80%;
  }
  .favorite{
    margin: 0 10px 0 0;
  }
}
</style>
